const CHANGE_LOCALE = 'CHANGE_LOCALE';

export { CHANGE_LOCALE };
